import React, { Component } from 'react';
import { connect } from "react-redux";
import { Button } from '../../ui';

import { numberWithDots } from '../../../helpers';
import soaImage from '../../../assets/autosSOA/soa.png';
import Loader from '../../Common/Loader';
import Text from '../../Common/Form/Text';
import {
  setVehiclesValue,
  cleanQuotation,
} from "../../../actions";
import { vehicles } from '../../../operations';
import Continue from "../../Common/Continue";

import iconCar from '../../../assets/autosSOA/btn-car-normal.png';
import iconCarError from '../../../assets/autosSOA/btn-car-error.png';
import iconCarPressed from '../../../assets/autosSOA/btn-car-pressed.png';
import iconTruck from '../../../assets/autosSOA/btn-truck-normal.png';
import iconTruckError from '../../../assets/autosSOA/btn-truck-error.png';
import iconTruckPressed from '../../../assets/autosSOA/btn-truck-pressed.png';
import iconTruck2 from '../../../assets/autosSOA/btn-truck-2-normal.png';
import iconTruck2Error from '../../../assets/autosSOA/btn-truck-2-error.png';
import iconTruck2Pressed from '../../../assets/autosSOA/btn-truck-2-pressed.png';
import iconBike from '../../../assets/autosSOA/btn-motorcycle-normal.png';
import iconBikeError from '../../../assets/autosSOA/btn-motorcycle-error.png';
import iconBikePressed from '../../../assets/autosSOA/btn-motorcycle-pressed.png';

class VehicleType extends Component {

  constructor(props) {
    super(props);

    this.state = {
      continue: false,
      vehicleVal: '',
      showTruckOptions: false,
    };

    this.handleVehicleTypeSelect = this.handleVehicleTypeSelect.bind(this);
    this.getVehicleTypeSelection = this.getVehicleTypeSelection.bind(this);
    this.getSelectionQuotation = this.getSelectionQuotation.bind(this);
    this.getFooterContent = this.getFooterContent.bind(this);
  }

  componentDidMount() {
    this.checkContinueState(null);
  }

  componentDidUpdate(prevProps, prevState) {
    this.checkContinueState(prevState);
  }

  continueCondition() {
    const { quoteId } = this.props;
    return ( quoteId !== 0 );
  }

  checkContinueState(prevState) {
    if (this.continueCondition()) {
      if (prevState === null || !prevState.continue) this.setState({ continue: true });
    } else {
      if (prevState === null || prevState.continue) this.setState({ continue: false });
    }
  }

  handleVehicleTypeSelect(val) {

    const { vehicleVal } = this.state;
    const { getCarBrands, onVehicleTypeSelect } = this.props;

    if (val === '') val = vehicleVal;
    this.setState({ vehicleVal: val });
    getCarBrands(val);

    if (val === 'camion') this.setState({ showTruckOptions: true });
    else this.setState({ showTruckOptions: false });

    onVehicleTypeSelect(val);
  }

  getVehicleTypeSelection() {

    const { showTruckOptions } = this.state;
    const { showError, vehicleType, truckWeight } = this.props;
    const error = showError && !vehicleType;

    return (
      <div className="AutosSoa-vehicles">
        <Text className="Text-question">Seleccione el tipo de vehículo para cotizar:</Text>

        <div className='AutosSoa-vehicles'>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <div
              className="AutosSoa-vehicle"
              onClick={() => this.handleVehicleTypeSelect('auto')}>
              <img className="AutosSoa-vehicleImage" alt="" src={error ? iconCarError : vehicleType === 'auto' ? iconCarPressed : iconCar} />
              <span>Auto</span>
            </div>
            <div
              className="AutosSoa-vehicle"
              onClick={() => this.handleVehicleTypeSelect('camion')}>
                <img className="AutosSoa-vehicleImage" alt="" src={error ? iconTruck2Error : vehicleType === 'camion' ? iconTruck2Pressed : iconTruck2} />
                <span>Camión</span>
            </div>
            <div
              className="AutosSoa-vehicle"
              onClick={() => this.handleVehicleTypeSelect('moto')}>
                <img className="AutosSoa-vehicleImage" alt="" src={error ? iconBikeError : vehicleType === 'moto' ? iconBikePressed : iconBike} />
                <span>Moto</span>
            </div>
          </div>

          {showTruckOptions && (
            <div className="AutosSoa-truckOptions">
              <div className="AutosSoa-truckOptions-item">
                <div className={`Form-radioWrapper ${truckWeight === false ? 'Form-radioWrapper--on' : ''}`}>
                  <input
                    type="radio"
                    name="truckWeight"
                    id="no"
                    value="false"
                    checked={truckWeight === false}
                    onChange={(event) => { setVehiclesValue('truckWeight', event.target.value === 'true'); }}
                  />
                </div>
                <label className="AutosSoa-weight" htmlFor="no">menor 7.000 Kg</label>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  getSelectionQuotation() {

    const {
      innerLoading, errorMessage,
      payment, vehicleType
    } = this.props;

    return (
      <div>
        {innerLoading ? <Loader message='' /> :
          <div>
            {
              errorMessage &&
              (
                <div className="AutosSoa-result">
                  <div className="AutosSoa-resultBody">
                    <div className="AutosSoa-resultInner">
                      <div className="AutosSoa-resultText">
                        <div className="AutosSoa-resultTitle"> {errorMessage} </div>
                      </div>
                    </div>
                  </div>
                  <div style={{ textAlign: 'center' }}>
                    <Button
                      onClick={() => this.handleVehicleTypeSelect('')}> Volver a intentar </Button>
                  </div>
                </div>
              )
            }
            {
              payment > 0 &&
              (
                <div>
                  <div className="AutosSoa-resultBody">
                    <div className="AutosSoa-resultInner">
                      <div className="AutosSoa-resultImage">
                        <img src={soaImage} alt="SOA" />
                      </div>
                      <div className="AutosSoa-resultText">
                        <span className="AutosSoa-resultTitle">Su inversión será de:</span>
                        <span className="AutosSoa-resultPrice">
                          $U {numberWithDots(payment)} <span>/ año</span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="AutosSoa-resultFooter">
                    {vehicleType === 'auto' &&
                      <span>
                        <span className="AutosSoa-icon-check" style={{ marginRight: 16 }} />
                        Esta cotización no incluye vehículos del tipo UBER y TAXIS
                      </span>
                    }
                  </div>
                </div>
              )
            }
          </div>
        }
      </div>
    );
  }

  getFooterContent() {
    return (
      <div className="AutosSoa-footer">
        <strong style={{ marginBottom: 4, display: 'block' }}>
          <span style={{ marginRight: 8 }}>
            <span className="icon-help"> ? </span>
          </span>
          ¿Qué es el S.O.A.?
        </strong>
        <span style={{ textTransform: 'uppercase' }}> Seguro Obligatorio <br /> Automotores Ley 18.412 </span>
      </div>
    );
  }

  render() {

    const { continue: toContinue} = this.state;

    return (
      <div>
        {this.getVehicleTypeSelection()}
        {this.getSelectionQuotation()}
        {/*this.getFooterContent()*/}
        <Continue state={toContinue}/>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    showError: state.steps.showError,

    innerLoading: state.steps.isInnerLoading,
    payment: state.quotation.cashAmount,
    quoteId: state.quotation.quoteId,
    truckWeight: state.vehicles.truckWeight,
    vehicleType: state.vehicles.vehicleType,
    errorMessage: state.quotation.errorMessage,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getCarBrands: (type) => {
      dispatch(vehicles.getCarBrands(type, true));
    },
    onVehicleTypeSelect: (type) => {
      dispatch(cleanQuotation()); // limpiar cotizacion si hay
      dispatch(setVehiclesValue('vehicleType', type));
      dispatch(vehicles.getQuotation(false, true));
    },
    setVehiclesValue: (type, value) => {
      dispatch(setVehiclesValue(type, value));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(VehicleType);